import * as tslib_1 from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import TextInputLabel from './TextInputLabel';
import { FormHelpText } from '../Form';
import InputErrorMessage from './InputErrorMessage';
import InputWrapper from './InputWrapper';
import Count from './Count';
var TextInputWrapper = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  min-width: 0px;\n  padding: 0;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  border: 0px;\n  position: relative;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  min-width: 0px;\n  padding: 0;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  border: 0px;\n  position: relative;\n"])), function (props) { return props.theme.spacing.unit * 2; }, function (props) { return props.theme.spacing.unit; });
var disabledStyle = css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  opacity: 1;\n"], ["\n  opacity: 1;\n"])));
var inputSinglelineStyle = css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  height: 19px;\n"], ["\n  height: 19px;\n"])));
var inputStyle = css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  border: 0px;\n  box-sizing: content-box;\n  vertical-align: middle;\n  background: none;\n  margin: 0px;\n  font-size: ", "rem;\n  font-family: ", ";\n  color: ", ";\n  -webkit-tap-highlight-color: ", ";\n  display: block;\n  min-width: 0px;\n  width: 100%;\n  ::-moz-placeholder,\n  ::-webkit-input-placeholder,\n  ::-ms-input-placeholder {\n    color: ", ";\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:invalid {\n    box-shadow: none;\n  }\n"], ["\n  border: 0px;\n  box-sizing: content-box;\n  vertical-align: middle;\n  background: none;\n  margin: 0px;\n  font-size: ", "rem;\n  font-family: ", ";\n  color: ",
    ";\n  -webkit-tap-highlight-color: ",
    ";\n  display: block;\n  min-width: 0px;\n  width: 100%;\n  ::-moz-placeholder,\n  ::-webkit-input-placeholder,\n  ::-ms-input-placeholder {\n    color: ", ";\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:invalid {\n    box-shadow: none;\n  }\n"])), function (props) { return props.theme.typography.subheading.fontSize; }, function (props) { return props.theme.typography.fontFamily; }, function (props) {
    return props.disabled
        ? props.theme.palette.text.disabled
        : props.theme.palette.input.inputText;
}, function (props) {
    return props.theme.palette.background.transparent;
}, function (props) { return props.theme.palette.text.hint; });
var BottomWrapper = styled.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyleInput = styled.input(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  padding: 6px 0 7px;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  padding: 6px 0 7px;\n  ", ";\n  ", ";\n  ", ";\n"])), inputStyle, function (props) { return props.disabled && disabledStyle; }, function (props) { return !props.multiline && inputSinglelineStyle; });
var StyleTextarea = styled.textarea(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  resize: none;\n  padding: 0;\n  line-height: 1.375rem;\n  overflow: auto;\n  ", ";\n  ", ";\n"], ["\n  resize: none;\n  padding: 0;\n  line-height: 1.375rem;\n  overflow: auto;\n  ", ";\n  ", ";\n"])), inputStyle, function (props) { return props.disabled && disabledStyle; });
/**
 * 文本表单域组件
 *
 * @ReactComponent
 */
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            valueLength: _this.props.value ? _this.props.value.length : 0,
        };
        _this.handleBlur = function (event) {
            _this.setState({
                focused: false,
            });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.handleFocus = function (event) {
            _this.setState({
                focused: true,
            });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.handleChange = function (event) {
            var value = (event && event.target && event.target.value) || '';
            _this.setState({ valueLength: value.length });
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        _this.handleRefInput = function (node) {
            _this.input = node;
            if (_this.props.inputRef) {
                _this.props.inputRef(node);
            }
            else if (_this.props.inputProps &&
                typeof _this.props.inputProps.ref === 'function') {
                _this.props.inputProps.ref(node);
            }
        };
        return _this;
    }
    TextField.prototype.handlePlaceholder = function () {
        var _a = this.props, fix = _a.fix, placeholder = _a.placeholder;
        if (fix) {
            return placeholder;
        }
        else if (placeholder && this.state.focused) {
            return placeholder;
        }
        return '';
    };
    TextField.prototype.render = function () {
        var _a = this.props, label = _a.label, helpText = _a.helpText, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, disabled = _a.disabled, required = _a.required, value = _a.value, defaultValue = _a.defaultValue, placeholder = _a.placeholder, type = _a.type, readOnly = _a.readOnly, multiline = _a.multiline, errorMessage = _a.errorMessage, fix = _a.fix, count = _a.count, other = tslib_1.__rest(_a, ["label", "helpText", "onKeyUp", "onKeyDown", "disabled", "required", "value", "defaultValue", "placeholder", "type", "readOnly", "multiline", "errorMessage", "fix", "count"]);
        var inputProps = tslib_1.__assign({}, other, { innerRef: this.handleRefInput, onChange: this.handleChange, onKeyUp: onKeyUp,
            onKeyDown: onKeyDown, onBlur: this.handleBlur, onFocus: this.handleFocus, disabled: disabled, required: required ? true : undefined, value: value,
            defaultValue: defaultValue, placeholder: this.handlePlaceholder(), 'aria-required': required, 'aria-invalid': errorMessage && errorMessage.length > 0 });
        var valueLength = this.state.valueLength;
        return (React.createElement(TextInputWrapper, null,
            label && (React.createElement(TextInputLabel, { disabled: disabled, error: (errorMessage && errorMessage.length > 0) || valueLength > count, focused: this.state.focused, shrink: fix
                    ? true
                    : this.state.focused || !value || typeof value === 'number', required: required }, label)),
            React.createElement(InputWrapper, { disabled: disabled, error: (errorMessage && errorMessage.length > 0) || valueLength > count, multiline: multiline, focused: this.state.focused }, multiline ? (React.createElement(StyleTextarea, tslib_1.__assign({}, inputProps))) : (React.createElement(React.Fragment, null,
                this.props.startComponent && this.props.startComponent,
                React.createElement(StyleInput, tslib_1.__assign({ type: type }, inputProps)),
                this.props.endComponent && this.props.endComponent))),
            React.createElement(BottomWrapper, null,
                helpText && React.createElement(FormHelpText, null, helpText),
                errorMessage && (React.createElement(InputErrorMessage, null, errorMessage)),
                count && (React.createElement(Count, { count: count, number: valueLength, error: valueLength > count })))));
    };
    TextField.sinouiName = 'TextField';
    return TextField;
}(React.PureComponent));
export default TextField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=TextField.js.map